import { connect } from "react-redux";
import React, { useState } from "react";
import { Button, Modal, Form } from "react-bootstrap";

import { userLoginStart } from "../../store/actions/UserAction";

const OTPModal = ({ show, data, handleClose, ...props }) => {
  const [code, setCode] = useState(null);

  const onSubmit = () => {
    props.dispatch(
      userLoginStart({
        ...data,
        code,
      })
    );
  };

  return (
    <Modal
      size="lg"
      show={show}
      onHide={handleClose}
      className={`verify light`}
    >
      <Modal.Header>OTP</Modal.Header>
      <Modal.Body>
        <div
          style={{
            padding: 20,
          }}
        >
          <div
            style={{
              padding: 20,
            }}
          >
            <Form translate="no">
              <Form.Control
                type="text"
                value={code}
                onChange={(event) => setCode(event.target.value)}
                required
              />
            </Form>
          </div>
        </div>
      </Modal.Body>
      <div className="footer">
        <Button variant="default" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="default" type="submit" onClick={() => onSubmit()}>
          Submit
        </Button>
      </div>
    </Modal>
  );
};

const mapStateToPros = (state) => ({
  modals: state.modals,
  profile: state.users.profile,
});

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(mapStateToPros, mapDispatchToProps)(OTPModal);
